  

    <h2 mat-dialog-title>
      <span  class="groupIcon" ><mat-icon>note_add</mat-icon></span>
     My Drive
      <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
    </h2>
    <mat-dialog-content>    
      <div class="myforms">      
        <div class="drive mainLink">
          <div class="taskLocation">
            <span (click)="breadCrumbMyDriveMainClick()">My Drive</span>
            <span *ngFor="let m of menuHeaderMyDrive;let i= index;">
              <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
              <a (click)="breadCrumbMyDrive(menuHeaderMyDrive, i)">{{ m.label }}</a>
            </span>
          </div>
          
          <mat-tree [dataSource]="dataSourceFileManager" [treeControl]="treeControlFileManager">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node  [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
             *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20">
              <div class="folderRow">
                 <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility: hidden;"> 
                   arrow_right
                  </mat-icon>                
             
                <div class="folderName">
                  <mat-icon class="folder" *ngIf="node.isShared == false" (click)="showChildFolders(node)">folder</mat-icon>
                  <mat-icon class="folder" *ngIf="node.isShared == true" (click)="showChildFolders(node)">folder_shared</mat-icon>
                  <span class="flname" (click)="showChildFolders(node)">{{node.name}}</span>
                </div>
              </div>
            </mat-tree-node>
  
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node  [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
              *matTreeNodeDef="let node;when: hasChild"  matTreeNodePadding matTreeNodePaddingIndent="20">
              <div class="folderRow"  matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                  {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
                </mat-icon>                
                <div class="folderName">
                  <mat-icon class="folder" *ngIf="node.isShared == false" (click)="showChildFolders(node)">folder</mat-icon>
                  <mat-icon class="folder" *ngIf="node.isShared == true" (click)="showChildFolders(node)">folder_shared</mat-icon>                 
                  <span class="flname" (click)="showChildFolders(node)">{{node.name}}</span>
                </div>
              </div>              
            </mat-tree-node>
          </mat-tree>      
        </div>         
      </div>
  
    </mat-dialog-content>
    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-flat-button   color="basic" (click)="close()">Cancel</button>
      <button mat-flat-button  color="primary" [disabled]="!selectButtonMyDriveShow" (click)="onFolderSelectToMove()">
        Move
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>




